module.exports = __webpack_public_path__ + "assets/img/win10warn.b42f988d.png";